import React from 'react';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {
    Grid,
    Icon,
} from '../../components';
import {
    eventoService,
    subeventoService,
    areaService,
    avaliacaoService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class NotasDiscrepantes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsEventos: [],
            dsSubeventos: [],
            dsAreas: [],
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            dsNotasDiscrepantes: [],
            ano: '',
        };
    }

    async componentWillMount() {
        const anoAtual = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(anoAtual);
        this.setState({
            ano: anoAtual,
            dsEventos: eventos,
        });
    }
    async getNotasDiscrepantes(subevento, area) {
        const notasDiscrepantes = await avaliacaoService.getNotasDiscrepantes(subevento, area);
        this.setState({ dsNotasDiscrepantes: notasDiscrepantes });
    }

    async buscarSubEventosPeloEvento(evento) {
        //  this._csrf = (await subeventoService.subeventoForm()).token;
        this.setState({
            eventoSelecionado: evento,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
        });

        const dadosSubevento = await subeventoService.getSubeventosDoEvento(evento);
        this.setState({ dsSubeventos: dadosSubevento });
    }

    async buscarEventosPeloAno(ano) {
        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({ dsEventos: eventos });
    }

    async buscarAreasPeloSubEvento(subevento) {
        const areas = await areaService.getAreasCoordenador(subevento);
        this.setState({ dsAreas: areas, subeventoSelecionado: subevento });
    }

    async buscarAreas(area) {
        const { subeventoSelecionado } = this.state;

        this.setState({ areaSelecionada: area });
        this.getNotasDiscrepantes(subeventoSelecionado, area);
    }

    render() {
        const {
            dsEventos,
            eventoSelecionado,
            areaSelecionada,
            subeventoSelecionado,
            dsSubeventos,
            dsAreas,
            ano,
            dsNotasDiscrepantes,
        } = this.state;

        return (
            <PrincipalMaster title="Notas Discrepantes" {...this.props}>
                <div>
                    <div className="padding-content">
                        <NumberFormat
                            format="####"
                            customInput={TextField}
                            required
                            value={ano}
                            errorText={ano ? '' : 'Campo obrigatório'}
                            floatingLabelText="Ano"
                            onBlur={e => this.buscarEventosPeloAno(e.target.value)}
                            onChange={e => this.setState({ ano: e.target.value })}
                        />
                        <br />

                        <SelectField
                            floatingLabelText="Selecione um evento"
                            value={eventoSelecionado}
                            onChange={(_event, _index, value) => this.buscarSubEventosPeloEvento(value)}
                            errorText={eventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            {
                                dsEventos.map(evento => (
                                    <MenuItem key={evento.CODIGO} value={evento.CODIGO} primaryText={evento.NOME} />
                                ))
                            }
                        </SelectField>

                        <SelectField
                            floatingLabelText="Selecione um subevento"
                            value={subeventoSelecionado}
                            onChange={(_event, _index, value) => this.buscarAreasPeloSubEvento(value)}
                            errorText={subeventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            <MenuItem value={0} />
                            {
                                dsSubeventos.map(subevento => (
                                    <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                ))
                            }
                        </SelectField>

                        <SelectField
                            floatingLabelText="Selecione uma área"
                            value={areaSelecionada}
                            onChange={(_event, _index, value) => this.buscarAreas(value)}
                            errorText={areaSelecionada > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            <MenuItem value={0} />
                            {
                                dsAreas.map(area => (
                                    <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                ))
                            }
                        </SelectField>

                    </div>
                </div>

                <div>
                    <div className="padding-content">
                        <Grid
                            ref={(ref) => { this.projetosGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum projeto com notas discrepantes encontrado."
                            dataSource={dsNotasDiscrepantes}
                            columns={[
                                {
                                    text: 'Nome', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '250px',
                                },
                                {
                                    text: 'Instituição', name: 'INSTITUICAO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Nº Avaliadores', name: 'QTDEAVALIADORES', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },

                                {
                                    text: 'Notas', name: 'MEDIAS', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Diferença', name: 'DIFERENCA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    name: item => (
                                        <div>
                                            <a href={`/projeto-info/${item.PROJETOS_CODIGO}`} target="_blank" rel="noopener noreferrer">
                                                <IconButton tooltip="Visualizar" >
                                                    <Icon name="visibility" />
                                                </IconButton>
                                            </a>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>

                </div>
            </PrincipalMaster>
        );
    }
}

export default NotasDiscrepantes;
